/**
 * Stripe's minimum chargeable amount in USD, in cents. Set client-side
 * to gate the UI before the backend rejects with AMOUNT_MISMATCH; the
 * backend enforces the same floor regardless.
 *
 * Lives in its own module (no React, no design-system imports) so the
 * pure same-day helpers can share it without pulling in components.
 * `EstimatedResponsibility` re-exports it for the existing import path.
 */
export const STRIPE_USD_MIN_CENTS = 50;
